import { SOURCE_TYPES } from 'constants/source'

const METASEARCH_TRAFFIC_SOURCE_TYPES: ReadonlyArray<string> = [
  SOURCE_TYPES.METASEARCH,
  SOURCE_TYPES.LOGGEDIN_METASEARCH,
  SOURCE_TYPES.CUG_METASEARCH,
  SOURCE_TYPES.METASEARCH_SESSION,
  SOURCE_TYPES.CUG_METASEARCH_SESSION,
  SOURCE_TYPES.METASEARCH_PRICE_VERIFIER,
]

export const METASEARCH_RATE_SOURCE_TYPES: ReadonlyArray<string> = [
  SOURCE_TYPES.METASEARCH,
  SOURCE_TYPES.CUG_METASEARCH,
  SOURCE_TYPES.METASEARCH_SESSION,
  SOURCE_TYPES.CUG_METASEARCH_SESSION,
]

export function isMetasearchRateSource(source?: string): boolean {
  return !!source?.split(',').some(sourceType => METASEARCH_RATE_SOURCE_TYPES.includes(sourceType))
}

/**
 * Whether the source marks GHA/metasearch traffic in any of the forms `getSource` and
 * `ghaPricedRequest` write. Wider than `isMetasearchRateSource`, which only asks for the
 * metasearch rate types.
 */
export function isMetasearchTrafficSource(source?: string): boolean {
  return !!source?.split(',').some(sourceType => METASEARCH_TRAFFIC_SOURCE_TYPES.includes(sourceType))
}
